module.exports = __webpack_public_path__ + "media/images/lb/418-8253e09469f1cacf4fbc505873ff5ced.svg";